import React from 'react';
import axios from '../../axios';
import Loader from '../../loader';

const SectionDetails = ({
  company,
  product,
  productsDetails,
  setProductsDetails,
}) => {
  const [isCreating, setIsCreating] = React.useState(false);

  const initialProductsDetails = {
    id: '',
    company_id: company.id,
    product_id: product.id,
    type: null,
    stock: 0,
    recent_stock: 0,
    is_sold: false,
  };

  const addProductsDetail = React.useCallback(() => {
    setIsCreating(true);
    axios
      .post('/api/community/products/create_products_details', initialProductsDetails)
      .then((response) => {
        setProductsDetails((prev) => [...prev, response.data]);
      })
      .finally(() => {
        setIsCreating(false);
      });
  });

  const removeProductsDetail = React.useCallback(
    (productsDetailsId, index) => {
      axios
        .post(`/api/community/products/delete_products_details`, {
          id: productsDetailsId,
        })
        .then(() => {
          setProductsDetails((prev) => {
            const newProductsDetail = [...prev];
            newProductsDetail.splice(index, 1);
            return newProductsDetail;
          });
        });
  });

  return (
    <section id="plans">
      {productsDetails.map((productsDetail, index) => (
        <ProductsDetailsBox
          key={productsDetail.id}
          productsDetail={productsDetail}
          setProductsDetails={(plan) => {
            setProductsDetails((prev) => {
              const newProductsDetails = [...prev];
              newProductsDetails[index] = plan;
              return newProductsDetails;
            });
          }}
          isRemovable={productsDetails.length > 1}
          removeProductsDetail={() => {
            removeProductsDetail(productsDetail.id, index);
          }}
        />
      ))}
      {isCreating ? (
        <Loader isActive={isCreating} />
      ) : (
        <div className="container col-md-8 col-lg-6 p-0">
          <div className="d-flex justify-content-end mr-1">
            <button
              className="bg-white mt-1 border border-dark"
              onClick={() => addProductsDetail()}
            >
              <p className="text-fz-14px text-black-333 text-fw-normal m-1">
                ＋ 詳細の追加
              </p>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};
const ProductsDetailsBox = ({
  productsDetail,
  setProductsDetails,
  isRemovable,
  removeProductsDetail,
}) => {
  const updateProductsDetail = React.useCallback(() => {
    axios.post(`/api/community/products/update_products_details/${productsDetail.id}`, productsDetail);
  }, [productsDetail]);

  return (
    <div className="mb-2">
      <div className="shadow-sm mb-0 bg-white" style={{ borderRadius: '7px', border: '1px solid #d1dbe5' }}>
        <div className="container col-md-8 col-lg-6 p-3_5 border-bottom">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">詳細名</p>
            <input
              id="plan"
              className="col-8 p-0 w-100 textarea--eventreport text-right"
              value={productsDetail.name}
              onBlur={updateProductsDetail}
              onChange={(e) =>
                setProductsDetails({ ...productsDetail, name: e.target.value })
              }
              placeholder="例) Mサイズ"
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6 p-3_5 border-bottom">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">タイプ</p>
            <input
              id="plan"
              className="col-8 p-0 w-100 textarea--eventreport text-right"
              value={productsDetail.type}
              onBlur={updateProductsDetail}
              onChange={(e) =>
                setProductsDetails({ ...productsDetail, type: e.target.value })
              }
              placeholder="例) 色、サイズ"
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6 p-3_5 border-bottom">
          <div className="row justify-content-between p-1">
            <p className="col-4 pr-2 m-0">在庫数</p>
            <input
              id="plan"
              type="number"
              className="col-8 p-0 w-100 textarea--eventreport text-right"
              value={productsDetail.recent_stock}
              onBlur={updateProductsDetail}
              onChange={(e) =>
                setProductsDetails({ ...productsDetail, recent_stock: Number(e.target.value) })
              }
              placeholder="200"
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="row d-flex">
            <div className="col-7">
              {isRemovable && (
                <button
                  className="bg-white mt-1 w-100 border border-dark"
                  onClick={() => removeProductsDetail()}
                >
                  <p className="text-fz-14px text-black-333 text-fw-normal m-1">
                    ー 詳細の削除
                  </p>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionDetails;
